<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <refresh-item :show="showRefreshItem" @onRefresh="getStageConfig"></refresh-item>

    <stage-comment-item v-if="!showRefreshItem"></stage-comment-item>

    <single-message-dialog
      :show="showSingleMessageDialog"
      message="Collect the required documents when they are available."
      @onContinue="onContinueFromSingleMessageDialog"
    ></single-message-dialog>

    <cancelled-cheque-options-item
      :show="showCancelledChequeOptionsItem"
      :cancelled-cheque-options="cancelledChequeOptions"
      class="margin_top_20"
      @onUploadCancelledChequeSelected="onUploadCancelledChequeSelected"
      @onUploadBankStatementSelected="onUploadBankStatementSelected"
      @onNoneOfTheseSelected="onNoneOfTheseSelected"
    ></cancelled-cheque-options-item>

    <upload-cancelled-cheque-item
      class="margin_top_20"
      :show="showUploadCancelledChequeItem"
      :upload-instruction="cancelledChequeOptionInstruction"
      @cancelledChequeUploaded="completeCurrentTaskAndGetNextTask"
    ></upload-cancelled-cheque-item>

    <bank-statement-manual-upload-item
      ref="bankStatementUploadItem"
      :show="showBankStatementCollectionItem"
      :upload-only-front-page="true"
      :allow-only-p-d-f="false"
      :instruction="bankStatementUploadInstruction"
      @onBankStatementsUploaded="completeCurrentTaskAndGetNextTask"
    ></bank-statement-manual-upload-item>

  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import Loading from "../layout/Loading";
import RefreshItem from "../layout/RefreshItem";
import StageCommentItem from "../layout/StageCommentItem";
import ActivityNavigator, { Activities } from "../../utils/ActivityNavigator";
import DataSource from "../../data/DataSource";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import UploadCancelledChequeItem from "../layout/UploadCancelledChequeItem";
import CancelledChequeOptionsItem from "../layout/CancelledChequeOptionsItem";
import SingleMessageDialog from "../dialogs/SingleMessageDialog";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import BankStatementManualUploadItem from "../layout/BankStatementManualUploadItem";
import storageUtil from "../../utils/StorageUtil";

export default {
  name: "CancelledChequeCollectionActivity",
  components: {
    ActivityRedirectItem,
    ToolBar,
    ErrorAlertItem,
    Loading,
    RefreshItem,
    StageCommentItem,
    UploadCancelledChequeItem,
    CancelledChequeOptionsItem,
    BankStatementManualUploadItem,
    SingleMessageDialog
  },

  data: () => ({
    toolbarTitle: "Cancelled Cheque Collection",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,
    showSingleMessageDialog: false,
    cancelledChequeOptionInstruction: "",
    showCancelledChequeOptionsItem: false,
    showUploadCancelledChequeItem: false,
    showBankStatementCollectionItem: false,
    cancelledChequeOptions: []
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onUploadCancelledChequeSelected() {
      this.showCancelledChequeOptionsItem = false;
      this.showUploadCancelledChequeItem = true;
    },

    onUploadBankStatementSelected() {
      this.showCancelledChequeOptionsItem = false;
      this.showBankStatementCollectionItem = true;
      this.$refs.bankStatementUploadItem.fetchInitialData();
    },

    onNoneOfTheseSelected() {
      this.showSingleMessageDialog = true;
    },

    onContinueFromSingleMessageDialog() {
      ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
    },

    getStageConfig() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), this.currentTaskName)
        .then(stageConfigDataRes => {
          this.loading = false;
          if (stageConfigDataRes.errorOccurred) {
            this.showError(stageConfigDataRes.data);
            this.showRefreshItem = true;
          } else {
            const configData = stageConfigDataRes.data;
            if (configData.properties
              && configData.properties["cancelled.cheque.options"]
              && configData.properties["cancelled.cheque.options"].length > 0
            ) {
              this.cancelledChequeOptionInstruction = configData.properties["stage.instructions"];
              this.cancelledChequeOptions = configData.properties["cancelled.cheque.options"];
              this.showCancelledChequeOptionsItem = true;
            }
          }
        })
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    }
  },

  created() {
    this.getStageConfig();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.CANCELLED_CHEQUE_COLLECTION];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    bankStatementUploadInstruction() {
      return `<div style="text-align: center"><span style="font-size: 16px; color: black; font-weight: bold;">Please upload Bank Statement PDF or Front Page image</span></div>`;
    },
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

